import { makeStyles } from '@material-ui/core/styles';
import { calculateWidth } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

const rightLeftPadding = '2.08vw';

export const styles = makeStyles(() => ({
  dialogPaper: {
    borderRadius: 2,
    minHeight: '65.36vh',
  },
  alertMenuContainer: {
    padding: `0 ${rightLeftPadding}`,
  },
  alertMenuLeft: {
    borderRight: `2px solid ${themeColor.secondaryLight}`,
    paddingRight: rightLeftPadding,
    textAlign: 'center',
  },
  alertMenuLeftBottom: {
    height: '7.29vh',
  },
  alertMenuRight: {
    paddingLeft: rightLeftPadding,
    flex: '1 1 0',
  },
  alertMenuFullHeight: {
    height: '100%',
  },
  actionButtonItemContainer: {
    width: calculateWidth(247 - 10).stringValue,
  },
  closeButton: {
    marginBottom: 0,
  },
  pagination: { width: 'auto' },
  alertMenu: { backgroundColor: themeColor.lightBackground },
  customContainerHeight: {
    height: '45vh',
  },
}));
